import "./NumericPagination.css";

import React, { useEffect } from "react";
import PropTypes from "prop-types";

import ChevronLeftIcon from "../../assets/imgs/chevron-left-icon.svg";
import ChevronRightIcon from "../../assets/imgs/chevron-right-icon.svg";
import { useIsMobile } from "../../hooks/useMediaQuery";

import "bootstrap/dist/css/bootstrap.min.css";

const MOBILE_PAGES_PER_VIEW = 2;
const DESKTOP_PAGES_PER_VIEW = 10;

const NumericPagination = ({ currentPage, totalPages, onSelectPage, pagesPerView }) => {
  const isMobile = useIsMobile();
  const pageIsUnavailable = (page) => !totalPages || page > totalPages;
  const resolvedPagesPerView = pagesPerView || DESKTOP_PAGES_PER_VIEW;
  const shownPagesPerView = isMobile
    ? MOBILE_PAGES_PER_VIEW
    : resolvedPagesPerView;
  const [pages, setPages] = React.useState([]);

  const getPagesFrom = (page) => {
    const tenCurrentPages = [];
    let firstNumberOfTheTen;

    firstNumberOfTheTen = page - (page % shownPagesPerView) + 1;

    for (let i = firstNumberOfTheTen; i < firstNumberOfTheTen + shownPagesPerView; i++) {
      tenCurrentPages.push(i);
    }

    return tenCurrentPages;
  }

  const getPageItemStyle = (page) => {
    const itemStyle = "numeric-pagination__button";

    if (page === currentPage) {
      return `${itemStyle} selected-page`;
    }

    if (pageIsUnavailable(page)) {
      return `${itemStyle} disabled-page`;
    }

    return itemStyle;
  }

  const handleSelectPage = (page) => {
    if (pageIsUnavailable(page)) {
      return;
    }

    const isLastShownPage = page > pages[shownPagesPerView - 2];
    const isFirstShownPage = page < pages[0] - 1;

    if (isLastShownPage) {
      setPages(getPagesFrom(page + 1));
    } else if (isFirstShownPage) {
      setPages(getPagesFrom(page - shownPagesPerView + 1));
    }

    onSelectPage(page);
  }

  useEffect(() => {
    setPages(getPagesFrom(currentPage - 1));
  }, [currentPage, shownPagesPerView]);

  return (
    <div className="numeric-pagination">
      {currentPage > 1 ? (
        <button
          type="button"
          className="numeric-pagination__button"
          onClick={() => handleSelectPage(currentPage - 2)}
        >
          <img src={ChevronLeftIcon} alt="Página anterior" />
        </button>
      ) : (
        <div className="numeric-pagination__button disabled-page">
          <img src={ChevronLeftIcon} alt="Página anterior" />
        </div>
      )}
      {pages?.map((page) => (
        pageIsUnavailable(page) ? (
          <div
            key={page}
            className={getPageItemStyle(page)}
          >
            {page}
          </div>
        ) : (
          <button
            type="button"
            key={page}
            className={getPageItemStyle(page)}
            onClick={() => handleSelectPage(page - 1)}
          >
            {page}
          </button>
        )
      ))}
      {currentPage < totalPages ? (
        <button
          type="button"
          className="numeric-pagination__button numeric-pagination__button--last next-page"
          onClick={() => handleSelectPage(currentPage)}
        >
          <img src={ChevronRightIcon} alt="Próxima página" />
        </button>
      ) : (
        <div className="numeric-pagination__button numeric-pagination__button--last disabled-page">
          <img src={ChevronRightIcon} alt="Próxima página" />
        </div>
      )}
    </div>
  )
}

NumericPagination.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onSelectPage: PropTypes.func,
  pagesPerView: PropTypes.number,
};

export default NumericPagination;